export default __webpack_public_path__ + "static/media/consumablesCover.9bf71fe1.svg";